<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      {{ $bct(placementProblemMessage ? 'No seats available' : 'Verification complete') }}
    </v-card-title>

    <v-card-text class="pt-6 pb-6">
      <div class="mb-4">
        {{ $bct(placementProblemMessage || 'Thank you for verifying, child has been placed.') }}
      </div>

      <div
        v-if="enrollment"
        class="d-flex align-center justify-between mb-4 bg-super-light-blue pa-3"
      >
        <div>
          <div class="fs-18 fw-600 mb-1">
            {{ enrollment.name }}
          </div>
          <div class="c-light-black">{{ $bct('DOB') }}: {{ enrollment.meta?.child?.dob }}</div>
        </div>

        <v-spacer />

        <v-icon
          :icon="placementProblemMessage ? 'error_outline' : 'check_circle'"
          class="me-3"
          color="primary"
          size="24"
        />
      </div>
    </v-card-text>

    <v-card-actions class="d-flex justify-end pa-4">
      <v-btn
        @click="$emit('confirm')"
        color="primary"
        variant="flat"
      >
        {{ $bct('Done') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  enrollment: {
    type: Object,
    default: null,
  },
});

defineEmits(['confirm']);

defineExpose({ open });

const placementProblemMessage = computed(
  () => props.enrollment?.meta?.verified_coc_placement_problem?.message,
);
</script>
